import React from "react";
import "../../styles/components/facultyProfile/consultationHoursSection.scss";
import { Button, Table, Typography, Tag } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

export default function ConsultationHoursSection({
  columns,
  data,
  selectedTerm,
  onAdd,
  onEdit,
}) {
  const filteredData = (data) =>
    selectedTerm
      ? data.filter((item) => selectedTerm.includes(item.academic_term))
      : data;

  return (
    <div className="consultation-hours-section">
      <div className="header">
        <Typography.Title
          level={3}
          style={{
            margin: 0,
            color: "#8b1438",
            fontFamily: "Palatino",
          }}
        >
          Consultation Hours
        </Typography.Title>

        <div className="header-row">
          <div>
            <span className="filter-label">Academic Term: </span>
            <Tag>{selectedTerm}</Tag>
          </div>

          <Button
            size="large"
            style={{ background: "#00573F" }}
            icon={<PlusCircleOutlined />}
            type="primary"
            onClick={onAdd}
          >
            Add
          </Button>
        </div>
      </div>

      <Table
        columns={columns}
        dataSource={filteredData(data)}
        scroll={{ x: "max-content" }}
        pagination={{ pageSize: 4 }}
        onRow={(record) => ({
          onClick: () => {
            if (onEdit) onEdit(record);
          },
          style: { cursor: "pointer" },
        })}
        rowKey={(record) => record.id}
      />
    </div>
  );
}
